import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { resolveCheckoutRouting } from './checkout-routing.helper';

export const checkoutGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();
  const previousUrl = navigation?.previousNavigation?.finalUrl?.toString() ?? '';

  // If user pops history back into /user/checkout from /review-order, the entry is phantom
  // (the redirect happened so the user never logically visited /user/checkout). Skip past it.
  if (navigation?.trigger === 'popstate' && previousUrl.startsWith('/review-order')) {
    history.back();
    return false;
  }

  const resolution = await resolveCheckoutRouting(
    route,
    inject(ConnectionService),
    inject(ExperimentService),
  );

  if (resolution.isRegimenReorder) {
    await router.navigate(['/review-order'], { queryParams: route.queryParams });
    return false;
  }

  if (resolution.skip || resolution.hasDefaultAddress) return true;

  await router.navigate(['/review-order'], {
    queryParams: route.queryParams,
  });
  return false;
};
